import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import PageHero from "../components/PageHero";
import { Reveal, RevealLines } from "../components/Reveal";
import { useI18n } from "../i18n";

const IMAGES = [
  "https://images.unsplash.com/photo-1655919640606-28088c64edb0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  "https://images.unsplash.com/photo-1568101671082-dbd18c6a9b31?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  "https://images.unsplash.com/photo-1771270759486-1f7703945072?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  "https://images.unsplash.com/photo-1765285334055-e2ecffe7ccc0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  "https://images.unsplash.com/photo-1598928506311-c55ded91a20c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  "https://images.unsplash.com/photo-1780863169728-29e9af6f70a2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  "https://images.unsplash.com/photo-1759662280562-c16a625f5fa3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  "https://images.unsplash.com/photo-1431540015161-0bf868a2d407?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
];

export default function Services() {
  const { t } = useI18n();
  const [active, setActive] = useState(0);
  return (
    <>
      <PageHero label={t.services.label} title={t.services.heading} image={IMAGES[5]} />
      <section className="bg-[#F7F5F0] py-24 md:py-32">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10">
          <Reveal><p className="font-body text-[#2A2A2A]/75 text-xl md:text-2xl leading-relaxed max-w-3xl mb-20">{t.services.body}</p></Reveal>
          <div className="grid md:grid-cols-12 gap-12">
            <div className="md:col-span-7">
              {t.services.list.map((s, i) => (
                <div
                  key={i}
                  onMouseEnter={() => setActive(i)}
                  data-testid={`service-row-${i}`}
                  className="group border-b border-[#2A2A2A]/12 py-8 hover:pl-3 transition-all duration-500 cursor-default"
                >
                  <div className="flex items-baseline justify-between gap-6">
                    <div>
                      <span className="font-serif-display text-[#C5A880] text-sm mr-4">{String(i + 1).padStart(2, "0")}</span>
                      <span className="font-serif-display text-[#062029] text-3xl md:text-5xl group-hover:text-[#C5A880] transition-colors duration-300">{s.t}</span>
                    </div>
                    <ArrowUpRight size={20} className="text-[#C5A880] opacity-0 group-hover:opacity-100 transition-opacity duration-300 shrink-0" />
                  </div>
                  <p className="font-body text-[#2A2A2A]/60 mt-3 md:pl-10">{s.d}</p>
                </div>
              ))}
            </div>
            <div className="md:col-span-5 hidden md:block">
              <div className="sticky top-28 h-[72vh] overflow-hidden">
                {IMAGES.map((src, i) => (
                  <img key={i} src={src} alt="" className="absolute inset-0 w-full h-full object-cover transition-opacity duration-700" style={{ opacity: active === i ? 1 : 0 }} />
                ))}
                <div className="absolute inset-0 bg-[#062029]/10" />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="bg-[#062029] py-28 grain overflow-hidden">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 text-center">
          <RevealLines className="font-serif-display text-[#F7F5F0] text-3xl md:text-5xl leading-tight" lines={["Coordinate. Connect. Guide."]} />
          <Reveal delay={0.2}>
            <Link to="/contact" data-testid="services-cta" className="inline-flex items-center gap-3 mt-10 border border-[#C5A880]/60 text-[#F7F5F0] px-8 py-4 text-[12px] tracking-widest uppercase hover:bg-[#C5A880] hover:text-[#062029] transition-colors duration-500">
              {t.nav.cta} <ArrowUpRight size={16} />
            </Link>
          </Reveal>
        </div>
      </section>
    </>
  );
}
